"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShippedItemCount = exports.hasAllItemsShipped = exports.hasShipments = exports.getShipments = exports.getTransactionTypeAmount = exports.hasTransactionType = exports.getTransactionType = exports.isPaymentCapturedOffline = exports.hasTransactionPaymentCapturedOffline = exports.hasPendingAuthorization = exports.isAuthorizationPending = exports.getOrderDocumentPDFFilename = exports.hasPaymentCaptured = exports.isTransactionCaptured = exports.isOrderNotRefunded = exports.isOrderPaidFully = exports.isPaymentOffline = exports.canCapture = void 0;
var payment_service_1 = require("../../services/payment-service");
var canCapture = function (order) {
    return (order.transactions.some(function (item) { return item.payment_type === payment_service_1.TransactionPaymentType.ONLINE; }) &&
        !(0, exports.hasPaymentCaptured)(order));
};
exports.canCapture = canCapture;
var isPaymentOffline = function (payment) { return payment.type === 'offline'; };
exports.isPaymentOffline = isPaymentOffline;
var isOrderPaidFully = function (order) {
    return order.summary.total_paid.amount >= order.summary.total_due.amount;
};
exports.isOrderPaidFully = isOrderPaidFully;
var isOrderNotRefunded = function (order) {
    return order.summary.total_refunded.amount === 0;
};
exports.isOrderNotRefunded = isOrderNotRefunded;
var isTransactionCaptured = function (transaction) {
    return transaction.type === 'payment' && transaction.status === payment_service_1.TransactionStatus.FINISHED;
};
exports.isTransactionCaptured = isTransactionCaptured;
var hasPaymentCaptured = function (order) {
    return order.transactions.some(function (transaction) { return (0, exports.isTransactionCaptured)(transaction); });
};
exports.hasPaymentCaptured = hasPaymentCaptured;
var getOrderDocumentPDFFilename = function (document) {
    return "".concat(document.type, "_").concat(document.number, ".pdf");
};
exports.getOrderDocumentPDFFilename = getOrderDocumentPDFFilename;
var isAuthorizationPending = function (transaction) {
    return transaction.type === 'authorize' && transaction.status === payment_service_1.TransactionStatus.PENDING;
};
exports.isAuthorizationPending = isAuthorizationPending;
var hasPendingAuthorization = function (order) {
    return order.transactions.some(function (transaction) { return (0, exports.isAuthorizationPending)(transaction); });
};
exports.hasPendingAuthorization = hasPendingAuthorization;
var hasTransactionPaymentCapturedOffline = function (order) {
    return order.transactions.some(function (trans) { return (0, exports.isPaymentCapturedOffline)(trans); });
};
exports.hasTransactionPaymentCapturedOffline = hasTransactionPaymentCapturedOffline;
var isPaymentCapturedOffline = function (transaction) {
    return (transaction.type === 'payment' &&
        transaction.status === payment_service_1.TransactionStatus.FINISHED &&
        transaction.payment_type === 'offline');
};
exports.isPaymentCapturedOffline = isPaymentCapturedOffline;
var getTransactionType = function (order, type) {
    return order.transactions.find(function (transaction) { return transaction.type === type; });
};
exports.getTransactionType = getTransactionType;
var hasTransactionType = function (order, type) {
    return !!(0, exports.getTransactionType)(order, type);
};
exports.hasTransactionType = hasTransactionType;
var getTransactionTypeAmount = function (order, type) {
    var _a;
    return (_a = (0, exports.getTransactionType)(order, type)) === null || _a === void 0 ? void 0 : _a.amount;
};
exports.getTransactionTypeAmount = getTransactionTypeAmount;
var getShipments = function (order) { return order.shipments || []; };
exports.getShipments = getShipments;
var hasShipments = function (order) { return (0, exports.getShipments)(order).length > 0; };
exports.hasShipments = hasShipments;
var hasAllItemsShipped = function (order) {
    var shipped = order.shipments.reduce(function (totalShippedQty, currentShipment) {
        return (totalShippedQty +
            currentShipment.items.reduce(function (totalItemsQty, currentItem) { return totalItemsQty + currentItem.quantity; }, 0));
    }, 0);
    return shipped >= order.summary.total_items_count;
};
exports.hasAllItemsShipped = hasAllItemsShipped;
var getShippedItemCount = function (item) {
    var _a;
    if ((_a = item.shipments) === null || _a === void 0 ? void 0 : _a.length) {
        return item.shipments.reduce(function (a, curr) { return a + curr.quantity; }, 0);
    }
    return 0;
};
exports.getShippedItemCount = getShippedItemCount;
//# sourceMappingURL=order-helpers.js.map